// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-heading-section .ct-content .typo-h2-slim[data-v-2bd9ce45]{padding-top:0}.ct-heading-section[data-v-2bd9ce45]:not(:last-child){padding-bottom:clamp(17px,4vw,40px)}.ct-content[data-v-2bd9ce45]{max-width:60rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
